import {number} from 'yup';

import {apiClient} from 'core/apiClient';
import {CODIFIERS_LINK} from 'core/constants/codifiers';
import {
    DocumentUtilisationData,
    DocumentDropOutData,
    DocumentCommissioningData,
    GtinDetailRaw,
} from 'types/documents';

export async function fetchDocumentDropOutCreate(params: DocumentDropOutData): Promise<any> {
    const data: any = await apiClient.post('/marking/dropout', params);
    return {
        data,
    };
}
export async function fetchDocumentUtilisationCreate(
    params: DocumentUtilisationData,
): Promise<any> {
    const data: any = await apiClient.post('/marking/utilisation', params);
    return {
        data,
    };
}

export async function fetchDocumentCommissioningCreate(
    params: DocumentCommissioningData,
): Promise<any> {
    const data: any = await apiClient.post('/marking/commissioning', params);
    return {
        data,
    };
}
export async function fetchDocumentUPDCreate(data: string | null): Promise<any> {
    const response: any = await apiClient.post('/marking/upd', data?.toString(), {
        headers: {'Content-Type': 'application/json'},
    });
    return {
        response,
    };
}

export async function fetchDocumentGtinInfo(codes: Array<string>): Promise<GtinDetailRaw[]> {
    const gtins = codes.map((item) => {
        if (/[0-9]/.test(item)) return item;
        return item
            .match(/01(.*?)21/g)?.[0]
            ?.replace(/01/, '')
            .replace(/21$/, '');
    });
    return (await apiClient.post(`/service/product-cards/by-marking-codes`, {markingCodes: gtins}))
        .data;
}

export async function fetchStorages() {
    return (
        await apiClient.get<{storageLocations: {id: number; storageName: string | null}[]}>(
            'service/profile/storage-locations',
        )
    ).data;
}

export async function fetchDocumentInvoiceCreate(params: string): Promise<any> {
    const data: any = await apiClient.post('/marking/invoice/load', params, {
        headers: {
            'Content-Type': 'application/xml',
        },
    });
    return {
        data,
    };
}

export async function fetchDocumentInvoiceXmlValidation(params: string): Promise<any> {
    const data: any = await apiClient.post('/marking/invoice/validate', params, {
        headers: {
            'Content-Type': 'application/xml',
        },
    });
    return {
        data,
    };
}

export async function fetchDocumentInvoiceQR(irn: string) {
    return (await apiClient.get<string>('/marking/invoice/qr', {params: {irn}})).data;
}

export async function fetchInvoiceIrn(): Promise<any> {
    const data: any = await apiClient.get('/service/invoice/generation-irn');
    return {
        data: data.data,
    };
}

export async function fetchCodeForServiceOrProducts(params: {
    isService: boolean;
    params: {
        code: string;
        size: number;
        number: number;
    };
}): Promise<any> {
    const url = params.isService
        ? `${CODIFIERS_LINK}/api/v1/hsn/product`
        : `${CODIFIERS_LINK}/api/v1/hsn/service`;
    const data: any = await apiClient.get(url, {
        params: {
            code: params.params.code,
            size: params.params.size,
            number: params.params.number,
            sortDirection: 'DESC',
        },
    });
    return data.data;
}
